<div
    *ngIf="detailLoading"
    class="detail-convocation-skeleton !mx-auto !max-w-7xl !px-4 !pb-16 !pt-8 sm:!px-6"
    role="status"
    aria-label="Caricamento convocazione"
>
    <div class="!mb-8 !flex !items-center !justify-between">
        <div class="mister-sk !h-5 !w-28"></div>
        <div class="mister-sk !h-9 !w-[7.5rem] !rounded-lg"></div>
    </div>

    <div class="!mb-2 !flex !items-center !justify-between">
        <div class="mister-sk !h-3 !w-36"></div>
        <div class="mister-sk !h-6 !w-24 !rounded-full"></div>
    </div>

    <div class="mister-sk !mb-8 !h-10 !max-w-3xl !w-full"></div>

    <div class="!mb-8 !grid !grid-cols-1 !gap-5 sm:!grid-cols-2">
        <div
            class="!space-y-3 !rounded-2xl !border !border-border !bg-white !p-5"
        >
            <div class="mister-sk !h-3 !w-28"></div>
            <div class="mister-sk !h-5 !w-4/5"></div>
            <div class="mister-sk !h-7 !w-32"></div>
        </div>
        <div
            class="!space-y-3 !rounded-2xl !border !border-border !bg-white !p-5"
        >
            <div class="mister-sk !h-3 !w-24"></div>
            <div class="mister-sk !h-5 !w-full"></div>
            <div class="mister-sk !h-4 !w-5/6"></div>
            <div class="mister-sk !h-4 !w-2/3"></div>
        </div>
    </div>

    <div class="!mb-8 !space-y-3">
        <div class="mister-sk !h-3 !w-32"></div>
        <div class="mister-sk !h-4 !w-full"></div>
        <div class="mister-sk !h-4 !w-full"></div>
        <div class="mister-sk !h-4 !w-11/12"></div>
    </div>

    <div class="!mb-10 !space-y-3">
        <div class="mister-sk !h-3 !w-36"></div>
        <div class="mister-sk !h-10 !w-48 !rounded-lg"></div>
    </div>

    <div class="!border-t !border-border !pt-8">
        <div class="!mb-4 !flex !items-center !justify-between">
            <div class="mister-sk !h-3 !w-40"></div>
            <div class="mister-sk !h-6 !w-10 !rounded-full"></div>
        </div>
        <div class="!grid !grid-cols-1 !gap-0 sm:!grid-cols-2">
            <div
                *ngFor="let _ of invitedRowSkeletonPlaceholders"
                class="!flex !items-center !gap-3 !border-b !border-border !py-3 sm:!odd:pr-4 sm:!even:pl-4 sm:!even:border-l"
            >
                <div class="mister-sk !h-7 !w-7 !shrink-0 !rounded-full"></div>
                <div class="!min-w-0 !flex-1 !space-y-2">
                    <div class="mister-sk !h-4 !w-3/5 !max-w-[12rem]"></div>
                    <div class="mister-sk !h-3 !w-24"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="!detailLoading && convocation as c">
  <div class="!mx-auto !max-w-7xl !px-4 !pb-16 !pt-6 sm:!px-6 md:!pt-8">
    <div class="!mb-5 !flex !items-center !justify-between !gap-3 md:!mb-6">
      <button
        type="button"
        class="!inline-flex !items-center !gap-2 !border-0 !bg-transparent !p-0 !text-sm !font-semibold !text-subtle !no-underline hover:!text-strong"
        (click)="navigateBackToDashboard()"
      >
        <i class="bi bi-arrow-left !mb-0" aria-hidden="true"></i>
        Indietro
      </button>
      <button
        *ngIf="!readOnly"
        type="button"
        class="btn welldone-btn-gray"
        (click)="openEditDrawer()"
      >
        <i class="bi bi-pencil me-2" aria-hidden="true"></i>
        Modifica
      </button>
    </div>

    <section
      class="!overflow-hidden !rounded-3xl !border !border-border !bg-white !shadow-sm"
      aria-labelledby="convocation-title"
    >
      <div class="!flex !items-start !gap-4 !p-5 md:!gap-7 md:!p-8">
        <div
          class="date-tile !flex !w-20 !shrink-0 !flex-col !items-center !overflow-hidden !rounded-2xl !border !border-border !bg-white !text-center !shadow-sm md:!w-24"
          [class.date-tile--past]="relativeDay(c.date)?.past"
          aria-hidden="true"
        >
          <span class="date-tile__month !w-full !py-1 !text-xs !font-bold !uppercase !tracking-wider">
            {{ c.date | date: "MMM" : "" : "it" }}
          </span>
          <span class="!pt-1.5 !text-3xl !font-bold !leading-none !text-strong md:!text-4xl">
            {{ c.date | date: "d" : "" : "it" }}
          </span>
          <span class="!pb-2 !pt-1 !text-xs !font-semibold !text-subtle">
            {{ c.date | date: "EEE" : "" : "it" }}
          </span>
        </div>

        <div class="!min-w-0 !flex-1">
          <div class="!mb-2 !flex !flex-wrap !items-center !gap-2">
            <span
              class="!inline-flex !items-center !rounded-full !px-2.5 !py-0.5 !text-xs !font-semibold !ring-1 !ring-inset"
              [ngClass]="statusClass(c.status)"
            >
              {{ c.status }}
            </span>
            <span
              *ngIf="relativeDay(c.date) as when"
              class="!inline-flex !items-center !gap-1 !rounded-full !px-2.5 !py-0.5 !text-xs !font-semibold"
              [ngClass]="when.past ? '!bg-zinc-100 !text-zinc-600' : '!bg-sky-50 !text-sky-800'"
            >
              <i class="bi bi-clock !mb-0" aria-hidden="true"></i>
              {{ when.label }}
            </span>
            <span
              *ngIf="c.categoryName"
              class="!text-xs !font-semibold !uppercase !tracking-wider !text-subtle"
            >
              {{ c.categoryName }}
            </span>
          </div>
          <h1
            id="convocation-title"
            class="!mb-1 !text-2xl !font-bold !leading-tight !tracking-tight !text-strong md:!text-4xl"
          >
            {{ c.title }}
          </h1>
          <p class="!mb-0 !text-base !font-medium !text-subtle md:!text-lg">
            <time [attr.datetime]="c.date">
              {{ c.date | date: "EEEE d MMMM y" : "" : "it" }} · ore {{ c.date | date: "HH:mm" : "" : "it" }}
            </time>
          </p>
        </div>
      </div>

      <dl class="quick-facts !m-0 !grid !grid-cols-2 !border-t !border-border md:!grid-cols-4">
        <div class="!px-5 !py-4 md:!px-8">
          <dt class="!mb-1 !text-xs !font-bold !uppercase !tracking-wide !text-subtle">Orario</dt>
          <dd class="!m-0 !text-lg !font-bold !text-strong">{{ c.date | date: "HH:mm" : "" : "it" }}</dd>
        </div>
        <div class="!min-w-0 !px-5 !py-4 md:!px-8">
          <dt class="!mb-1 !text-xs !font-bold !uppercase !tracking-wide !text-subtle">Luogo</dt>
          <dd class="!m-0 !break-words !text-base !font-bold !leading-snug !text-strong md:!truncate md:!text-lg" [attr.title]="c.location">
            {{ c.location || "Da definire" }}
          </dd>
        </div>
        <div class="!px-5 !py-4 md:!px-8">
          <dt class="!mb-1 !text-xs !font-bold !uppercase !tracking-wide !text-subtle">Convocati</dt>
          <dd class="!m-0 !text-lg !font-bold !text-strong">
            {{ isMisterView ? invitedAthleteSeasons.length : invitedUsers.length }}
          </dd>
        </div>
        <div class="!px-5 !py-4 md:!px-8" *ngIf="isMisterView; else categoryFact">
          <dt class="!mb-1 !text-xs !font-bold !uppercase !tracking-wide !text-subtle">Non tesserati</dt>
          <dd
            class="!m-0 !flex !items-center !gap-1.5 !text-lg !font-bold"
            [ngClass]="invitedWithoutMembership > 0 ? '!text-amber-700' : '!text-emerald-700'"
          >
            <i
              class="bi !mb-0 !text-base"
              [ngClass]="invitedWithoutMembership > 0 ? 'bi-exclamation-triangle' : 'bi-check-circle'"
              aria-hidden="true"
            ></i>
            {{ invitedWithoutMembership }}
          </dd>
        </div>
        <ng-template #categoryFact>
          <div class="!min-w-0 !px-5 !py-4 md:!px-8">
            <dt class="!mb-1 !text-xs !font-bold !uppercase !tracking-wide !text-subtle">Categoria</dt>
            <dd class="!m-0 !break-words !text-base !font-bold !leading-snug !text-strong md:!truncate md:!text-lg">{{ c.categoryName || "—" }}</dd>
          </div>
        </ng-template>
      </dl>
    </section>

    <div class="!mt-5 !grid !gap-5 lg:!grid-cols-[minmax(0,1fr)_22rem]">
      <section class="!rounded-3xl !border !border-border !bg-white !p-5 !shadow-sm md:!p-7">
        <h2 class="!mb-3 !flex !items-center !gap-2 !text-xs !font-bold !uppercase !tracking-wide !text-subtle">
          <i class="bi bi-info-circle !mb-0" aria-hidden="true"></i>
          Cosa sapere
        </h2>
        <p
          *ngIf="c.description?.trim(); else noDescription"
          class="!mb-0 !whitespace-pre-line !text-base !leading-relaxed !text-strong md:!text-lg"
        >{{ c.description }}</p>
        <ng-template #noDescription>
          <p class="!mb-0 !text-sm !text-subtle">Nessuna indicazione aggiuntiva per questa convocazione.</p>
        </ng-template>
      </section>

      <aside class="!rounded-3xl !border !border-border !bg-white !p-5 !shadow-sm md:!p-7" aria-label="Luogo">
        <h2 class="!mb-3 !flex !items-center !gap-2 !text-xs !font-bold !uppercase !tracking-wide !text-subtle">
          <i class="bi bi-geo-alt !mb-0" aria-hidden="true"></i>
          Luogo
        </h2>
        <p class="!mb-1 !text-lg !font-bold !leading-snug !text-strong">
          {{ c.location || "Luogo da definire" }}
        </p>
        <address
          *ngIf="c.address?.trim() || cityLine(c)"
          class="!mb-0 !text-sm !not-italic !leading-relaxed !text-subtle"
        >
          <ng-container *ngIf="c.address?.trim()">{{ c.address }}</ng-container>
          <br *ngIf="c.address?.trim() && cityLine(c)" />{{ cityLine(c) }}
        </address>
        <p
          *ngIf="c.linkPosition?.trim() && !isLink(c.linkPosition)"
          class="!mb-0 !mt-3 !rounded-xl !bg-zinc-50 !px-3 !py-2 !text-sm !text-strong"
        >
          <i class="bi bi-signpost-2 !mb-0 !mr-1 !text-subtle" aria-hidden="true"></i>
          {{ c.linkPosition }}
        </p>
        <a
          *ngIf="directionsUrl(c) as url"
          [href]="url"
          target="_blank"
          rel="noopener noreferrer"
          class="btn btn-primary !mt-4 d-flex align-items-center justify-content-center !w-full"
        >
          <i class="bi bi-pin-map me-2" aria-hidden="true"></i>
          Apri sulla mappa
        </a>
      </aside>
    </div>

    <div class="!mt-10 !border-t !border-border !pt-8">
      <div class="!mb-4 !flex !items-center !justify-between">
        <p
          class="!mb-0 !text-xs !font-bold !uppercase !tracking-wide !text-subtle"
        >
          <i class="bi bi-people !mr-1 !mb-0" aria-hidden="true"></i>
          Chi è convocato
        </p>
        <span
          *ngIf="(isMisterView ? invitedAthleteSeasons : athleteViewInvitedUsers).length > 0"
          class="!rounded-full !bg-zinc-100 !px-2.5 !py-0.5 !text-xs !font-bold !text-zinc-600"
        >
          {{ isMisterView ? invitedAthleteSeasons.length : athleteViewInvitedUsers.length }}
        </span>
      </div>

      <ng-container *ngIf="isMisterView; else athleteInvitedList">
        <ng-container *ngIf="invitedAthleteSeasons.length > 0; else noPeople">
          <ng-container
            *ngTemplateOutlet="athleteSeasonTable; context: { rows: invitedAthleteSeasons }"
          ></ng-container>
        </ng-container>
      </ng-container>

      <ng-template #athleteInvitedList>
        <ng-container *ngIf="athleteViewInvitedUsers.length > 0; else noPeople">
          <div class="!grid !grid-cols-1 !gap-0 sm:!grid-cols-2">
            <div
              *ngFor="
                let user of athleteViewInvitedUsers;
                let i = index;
                trackBy: trackUserId
              "
              class="!flex !items-center !gap-3 !border-b !border-border !py-3 sm:!odd:pr-4 sm:!even:pl-4 sm:!even:border-l"
            >
              <span
                class="!flex !h-7 !w-7 !shrink-0 !items-center !justify-center !rounded-full !bg-zinc-100 !text-xs !font-bold !text-zinc-500"
              >
                {{ i + 1 }}
              </span>
              <span
                class="!block !truncate !text-sm !font-semibold !text-strong"
                >{{ user.fullName }}</span
              >
            </div>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #noPeople>
        <p class="!mb-0 !text-sm !text-subtle">
          Nessuna persona convocata per ora.
        </p>
      </ng-template>

      <div
        *ngIf="isMisterView && notInvitedAthleteSeasons.length > 0"
        class="!mt-8 !border-t !border-border !pt-8"
      >
        <div class="!mb-4 !flex !items-center !justify-between">
          <p
            class="!mb-0 !text-xs !font-bold !uppercase !tracking-wide !text-subtle"
          >
            <i class="bi bi-person-x !mr-1 !mb-0" aria-hidden="true"></i>
            Non convocati
          </p>
          <span
            class="!rounded-full !bg-zinc-100 !px-2.5 !py-0.5 !text-xs !font-bold !text-zinc-600"
          >
            {{ notInvitedAthleteSeasons.length }}
          </span>
        </div>
        <ng-container
          *ngTemplateOutlet="athleteSeasonTable; context: { rows: notInvitedAthleteSeasons }"
        ></ng-container>
      </div>
    </div>

    <ng-template #athleteSeasonTable let-rows="rows">
      <ul class="!m-0 !list-none !space-y-3 !p-0 md:!hidden">
        <li
          *ngFor="let row of rows"
          class="!rounded-2xl !border !border-border !bg-white !p-4 !shadow-sm"
        >
          <div class="!flex !items-start !justify-between !gap-3">
            <div class="!min-w-0">
              <p class="!mb-0.5 !font-bold !text-strong">
                {{ row.athlete.firstName }} {{ row.athlete.lastName }}
              </p>
              <p *ngIf="row.athlete.fiscalCode" class="!mb-0 !text-xs !text-subtle">
                {{ row.athlete.fiscalCode }}
              </p>
            </div>
            <div
              class="badge !shrink-0"
              [ngClass]="{
                'badge-success': isMembershipActive(row),
                'badge-error': !isMembershipActive(row)
              }"
            >
              {{ membershipLabel(row) }}
            </div>
          </div>
          <div class="!mt-3 !flex !flex-col !gap-1.5 !text-sm">
            <a
              *ngIf="row.athlete.phone"
              [href]="'tel:' + row.athlete.phone"
              class="!inline-flex !items-center !gap-2 !text-strong !no-underline"
            >
              <i class="bi bi-telephone !mb-0 !text-subtle" aria-hidden="true"></i>{{ row.athlete.phone }}
            </a>
            <a
              *ngIf="row.athlete.email"
              [href]="'mailto:' + row.athlete.email"
              class="!inline-flex !min-w-0 !items-center !gap-2 !text-strong !no-underline"
            >
              <i class="bi bi-envelope !mb-0 !text-subtle" aria-hidden="true"></i>
              <span class="!truncate">{{ row.athlete.email }}</span>
            </a>
          </div>
          <div
            *ngIf="membershipExpiryLabel(row) || primaryDocumentExists"
            class="!mt-3 !flex !flex-wrap !items-center !gap-2 !border-t !border-border !pt-3 !text-xs !text-subtle"
          >
            <span *ngIf="membershipExpiryLabel(row) as expiry">Tessera fino al {{ expiry }}</span>
            <span
              *ngIf="primaryDocumentExists"
              class="badge"
              [ngClass]="
                utils.remaningDays(row.athlete.primaryDocExpirationDate).status === 'success'
                  ? 'badge-success'
                  : utils.remaningDays(row.athlete.primaryDocExpirationDate).status === 'danger'
                    ? 'badge-error'
                    : utils.remaningDays(row.athlete.primaryDocExpirationDate).status === 'warning'
                      ? 'badge-warning'
                      : 'badge-unknown'
              "
            >
              Doc. {{ utils.remaningDays(row.athlete.primaryDocExpirationDate).text }}
            </span>
          </div>
        </li>
      </ul>

      <div class="convocation-detail-table-wrap table-responsive bg-white table-radius shadow-sm !hidden md:!block">
        <table class="table custom-ui-table !mb-0">
          <thead>
            <tr>
              <th class="text-start">Atleta / Recapiti</th>
              <th class="text-start">Tesseramento</th>
              <th *ngIf="primaryDocumentExists" class="text-start">Scadenza doc.</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of rows">
              <td>
                <div class="fw-bold text-dark">
                  {{ row.athlete.firstName }} {{ row.athlete.lastName }}
                </div>
                <div class="small text-muted">
                  {{ row.athlete.fiscalCode }}
                </div>
                <div class="small mt-1">
                  <i class="bi bi-telephone me-1"></i>{{ row.athlete.phone }}
                  <span class="mx-1">|</span>
                  <i class="bi bi-envelope me-1"></i>{{ row.athlete.email }}
                </div>
              </td>
              <td>
                <div class="d-flex flex-column align-items-start">
                  <div
                    class="badge"
                    [ngClass]="{
                      'badge-success': isMembershipActive(row),
                      'badge-error': !isMembershipActive(row)
                    }"
                  >
                    {{ membershipLabel(row) }}
                  </div>
                  <div
                    *ngIf="membershipExpiryLabel(row) as expiry"
                    class="small text-muted mt-1"
                  >
                    Scade il {{ expiry }}
                  </div>
                </div>
              </td>
              <td *ngIf="primaryDocumentExists">
                <div class="d-flex flex-column align-items-start">
                  <div
                    class="badge"
                    [ngClass]="
                      utils.remaningDays(row.athlete.primaryDocExpirationDate).status === 'success'
                        ? 'badge-success'
                        : utils.remaningDays(row.athlete.primaryDocExpirationDate).status === 'danger'
                          ? 'badge-error'
                          : utils.remaningDays(row.athlete.primaryDocExpirationDate).status === 'warning'
                            ? 'badge-warning'
                            : 'badge-unknown'
                    "
                  >
                    {{ utils.remaningDays(row.athlete.primaryDocExpirationDate).text }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-template>
  </div>
</ng-container>

<app-mister-convocation-form
  *ngIf="!readOnly"
  [isOpen]="formOpen"
  [convocation]="convocation"
  (closed)="formOpen = false"
  (saved)="onFormSaved($event)"
></app-mister-convocation-form>

<ng-container *ngIf="!detailLoading && !convocation">
  <div class="!mx-auto !max-w-2xl !px-4 !py-10 sm:!px-6">
    <button
      type="button"
      class="!mb-6 !inline-flex !items-center !gap-2 !border-0 !bg-transparent !p-0 !text-sm !font-semibold !text-subtle !no-underline"
      (click)="navigateBackToDashboard()"
    >
      <i class="bi bi-arrow-left !mb-0"></i>
      Indietro
    </button>
    <p class="!mb-2 !text-xl !font-bold !text-strong">Pagina non trovata</p>
    <p class="!mb-0 !text-sm !text-subtle">
      Questa convocazione non esiste o il link non è corretto.
    </p>
  </div>
</ng-container>
